import { authApiService } from '@/api/authApiService';
import { ApiResponseType, AuthResponseType } from '@/types/sharedTypes';

type SetAuthPinCodePayloadType = {
  pin: string;
};

export const setAuthPinCodeApi = (data: SetAuthPinCodePayloadType): Promise<ApiResponseType<AuthResponseType>> => {
  const uri = '/users/auth/pin:set/';

  return authApiService.POST(uri, data);
};
